import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

// Styled component for company field wrapper
export const CompanyFieldWrapper = styled("div")({
  position: "relative"
});

// Styled component for question icon
export const QuestionIcon = styled("div")({
  position: "absolute",
  top: "21px",
  left: "245px"
});

// Styled component for icon size
export const IconSize = styled("div")({
  width: "24px",
  height: "24px"
});

// Styled component for text grid
export const TextGrid = styled("div")({
  margin: "auto"
});

// Styled component for radio button root
export const RadioButtonRoot = styled("div")({
  width: "calc(33.33% - 20px)",
  padding: 5
});

// Styled component for error message
export const ErrorMessage = styled("div")({
  color: "#ea2b1e",
  lineHeight: 1,
  fontSize: 12,
  padding: "5px 45px"
});

// Styled component for map preview container
export const MapPreviewContainer = styled("div")({
  height: 250,
  borderRadius: 10,
  margin: 10,
  width: "100%",
  marginBottom: 20
});

// Styled component for preview container with responsive styling
export const PreviewContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    position: "absolute",
    right: 5,
    width: "calc(50% - 10px)"
  }
}));

// Styled component for padding
export const PaddingT4B18 = styled("div")({
  padding: "4px 0px 18px 0px !important"
});

// For backward compatibility, export a wrapper component
export const StyledWrapper = styled(Box)(({ theme }) => ({
  "& .divider": {
    height: "1px",
    backgroundColor: "rgba(230, 230, 230, 0.5)",
    margin: "30px 0 20px"
  },
  "& .companyFieldWrapper": {
    position: "relative"
  },
  "& .questionIcon": {
    position: "absolute",
    top: "21px",
    left: "245px"
  },
  "& .iconSize": {
    width: "24px",
    height: "24px"
  },
  "& .textGrid": {
    margin: "auto"
  },
  "& .radioButtonRoot": {
    width: "calc(33.33% - 20px)",
    padding: 5
  },
  "& .errorMessage": {
    color: "#ea2b1e",
    lineHeight: 1,
    fontSize: 12,
    padding: "5px 45px"
  },
  "& .mapPreviewContainer": {
    height: 250,
    borderRadius: 10,
    margin: 10,
    width: "100%",
    marginBottom: 20
  },
  "& .previewContainer": {
    [theme.breakpoints.up("sm")]: {
      position: "absolute",
      right: 5,
      width: "calc(50% - 10px)"
    }
  },
  "& .paddingT4B18": {
    padding: "4px 0px 18px 0px !important"
  }
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  minHeight: "30px",
  margin: "0 32px 0 20px"
}));

export const NameField = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 600,
  lineHeight: 1.33,
  color: "#373737",
  wordBreak: "break-all"
}));

export const SignatoryField = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  lineHeight: "1.71",
  color: "#517085"
}));

export const ShareholdingField = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  // lineHeight: '20px',
  color: "var(--Color-Text-Secondary-On-Light, #757575)",
  fontWeight: 400
}));

export const UserInfo = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  rowGap: "7px"
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 500,
  marginTop: theme.spacing(-1)
}));
export const Header = styled("header")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "16px"
}));

export const Placeholder = styled("p")(({ theme }) => ({
  width: "32px",
  height: "32px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50px",
  background: "var(--Color-Palette-Red-50, #FDE7E8)",
  fontSize: "16px",
  lineHeight: "140%",
  fontWeight: "400",
  color: "var(--Color-Text-Secondary-On-Light, #757575)",
  margin: 0,
  [theme.breakpoints.up("sm")]: {
    width: "54px",
    height: "54px",
    fontSize: "24px"
  }
}));

export const Divider = styled("div")(({ theme }) => ({
  width: "100%",
  height: "1px",
  backgroundColor: "#E6E6E6"
}));

export const ShareholderName = styled("span")(({ theme }) => ({
  margin: "0",
  fontSize: "16px",
  fontWeight: "500",
  // lineHeight: "0px !important",
  textTransform: "capitalize",
  color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
  [theme.breakpoints.up("sm")]: {
    fontSize: "20px",
    lineHeight: "28px !important"
  }
}));
